// Left side old name, right side new name
const nameMap = [
  ['analytics', 'chart-mixed'],
  ['balance-scale', 'scale-balanced'],
  ['birthday-cake', 'cake-candles'],
  ['bolt', 'bolt-lightning'],
  ['box-full', 'box-open-full'],
  ['boxes', 'boxes-stacked'],
  ['broadcast-tower', 'tower-broadcast'],
  ['cctv', 'camera-cctv'],
  ['calculator-alt', 'calculator-simple'],
  ['calender-alt', 'calendar-days'],
  ['check-circle', 'circle-check'],
  ['cocktail', 'martini-glass-citrus'],
  ['cogs', 'gears'],
  ['cloud-download-alt', 'cloud-arrow-down'],
  ['cloud-upload-alt', 'cloud-arrow-up'],
  ['edit', 'pen-to-square'],
  ['exclamation-circle', 'circle-exclamation'],
  ['exclamation-triangle', 'triangle-exclamation'],
  ['file-alt', 'file-lines'],
  ['glass-cheers', 'champagne-glasses'],
  ['globe-europe', 'earth-europe'],
  ['hard-hat', 'helmet-safety'],
  ['hands-heart', 'hands-holding-heart'],
  ['hand-holding-water', 'hand-holding-droplet'],
  ['heartbeat', 'heart-pulse'],
  ['home', 'house'],
  ['home-lg-alt', 'house'],
  ['info-circle', 'circle-info'],
  ['list-alt', 'rectangle-list'],
  ['magic', 'wand-magic-sparkles'],
  ['map-marker-alt', 'map-location-dot'],
  ['map-marked', 'map-location'],
  ['map-signs', 'signs-post'],
  ['minus-circle', 'circle-minus'],
  ['mobile-alt', 'mobile-screen-button'],
  ['people-carry', 'people-carry-box'],
  ['play-circle', 'circle-play'],
  ['plus-circle', 'circle-plus'],
  ['question-circle', 'circle-question'],
  ['save', 'floppy-disk'],
  ['search', 'magnifying-glass'],
  ['shield-alt', 'shield-halved'],
  ['shipping-fast', 'truck-fast'],
  ['shopping-basket', 'basket-shopping'],
  ['shopping-cart', 'cart-shopping'],
  ['sliders-h', 'sliders'],
  ['sliders-v', 'sliders-up'],
  ['sign-in', 'right-to-bracket'],
  ['sign-out', 'right-from-bracket'],
  ['sync', 'rotate'],
  ['tachometer', 'gauge-simple-low'],
  ['temperature-frigid', 'temperature-snow'],
  ['temperature-hot', 'temperature-sun'],
  ['th', 'grid'],
  ['thunderstorm', 'cloud-bolt'],
  ['tint', 'droplet'],
  ['times', 'xmark'],
  ['times-circle', 'circle-xmark'],
  ['tools', 'screwdriver-wrench'],
  ['trash-alt', 'trash-can'],
  ['tv-alt', 'tv'],
  ['user-friends', 'user-group'],
  ['user-hard-hat', 'user-helmet-safety'],
];

export const checkIfIconNameDeprecated = string => {
  const foundPair = nameMap.find(pair => pair.includes(string));
  if (foundPair) {
    // Take new naming
    return foundPair[1];
  }
  return string;
};
